/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { BoxIcon, BoxLogo, Container, Header } from "./styles";
import { Divider, IconButton, MenuList } from "@mui/material";
import { KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from "@mui/icons-material";
import { useEffect, useState } from "react";

import ListItemMenu from "./Buttons/menus";
import { colors } from "../../../theme/globalStyles";
import menuListItens from "./Buttons/menuItens";
import { useAuth } from "@/context/global";

interface IProps {
    width: number;
    expanded: boolean;
    onToggle: any;
}

interface IMenuProps {
    title?: any;
    icon?: any;
    router?: any;
    permissions?: any[];
    children?: any;
    divisor?: any;
}

export default function Sidebar({ width, expanded, onToggle }: IProps) {
    const { setRoutePermission, handleGetDataUser } = useAuth();
    const [itemSelected, setItemSelected] = useState<string>();
    const user = handleGetDataUser();

    useEffect(() => {
        let arrayPermission: any[] = [];
        menuListItens.map((item) => {
            if (item.children && item.children.length > 0) {
                item.children.map((e) => {
                    arrayPermission.push(e);
                });
            }
        });

        if (arrayPermission.length > 0) {
            setRoutePermission(arrayPermission);
        }
    }, []);

    return (
        <>
            <Container
                width={width}
                open={expanded}
                variant="permanent"
                PaperProps={{
                    sx: {
                        zIndex: 99,
                        backgroundColor: colors.blue,
                        color: "#fff",
                        border: "none",
                        borderTopRightRadius: 8,
                        borderBottonRightRadius: 8,
                        boxShadow: "4px 4px 5px #0000004D",
                    },
                }}
            >
                <Header>
                    <BoxIcon positionIcon={expanded}>
                        <IconButton size="small" onClick={onToggle}>
                            {!expanded ? <KeyboardDoubleArrowRight /> : <KeyboardDoubleArrowLeft />}
                        </IconButton>
                    </BoxIcon>
                    <BoxLogo>
                        {expanded ? (
                            <img src="../logos/logo.png" width="180px" height="70px" alt="logo" />
                        ) : (
                            <img src="../logos/logo_xs.png" height="60px" alt="logo" />
                        )}
                    </BoxLogo>
                </Header>
                <MenuList sx={{ p: 0 }}>
                    {/*  Pag home */}
                    <ListItemMenu
                        menuSelected={itemSelected}
                        item={{
                            title: "Página Inicial",
                            icon: "home",
                            router: "/",
                            permissions: [],
                            children: [],
                        }}
                        alterMenuSelected={(e: any) => {
                            setItemSelected(e);
                        }}
                        showSubmenu={expanded}
                    />
                    {/* serializa menu */}
                    {menuListItens.map((menu: IMenuProps, y: number) =>
                        menu.divisor ? (
                            <Divider key={y} />
                        ) : (
                            <div key={y}>
                                {menu.permissions &&
                                    user &&
                                    user?.perfil &&
                                    menu.permissions.includes(user?.perfil.toLowerCase()) && (
                                        <ListItemMenu
                                            item={menu}
                                            menuSelected={itemSelected}
                                            alterMenuSelected={(e: any) => {
                                                setItemSelected(e);
                                            }}
                                            showSubmenu={expanded}
                                        />
                                    )}
                            </div>
                        )
                    )}
                    <ListItemMenu
                        id="sair"
                        menuSelected={itemSelected}
                        item={{
                            title: "Sair",
                            icon: "logout",
                            router: null,
                            children: [],
                            permissions: [],
                        }}
                        alterMenuSelected={(e: any) => {
                            setItemSelected(e);
                        }}
                        showSubmenu={expanded}
                    />
                </MenuList>
            </Container>
        </>
    );
}
